<template>
  <div class="policyaAnnouncementBox">
    <div class="content">
      <breadcrumbCommon :dataArr="breadcrumb"></breadcrumbCommon>
      <div class="data-box data-policy-box">
        <h3>"{{ infoList.title }}"的解读</h3>
        <span class="date">发布时间：{{ infoList.createTime }}</span>
        <span class="apply" @click="goDetail">
          前往政策原文
          <Icon type="ios-arrow-forward"></Icon>
        </span>
        <div class="clear"></div>
        <div class="bgStyle">
          <p>导语</p>
          <span>{{ infoList.background }}</span>
          <p style="margin-top: 35px">背景</p>
          <span id="descText" :class="{ isMoreLine7: !descShowFlag && isMore }">{{ infoList.introduction }}</span>
        </div>
        <div v-if="!descShowFlag && isMore" @click="descShowFlag = true" class="showMore">
          查看更多
          <Icon style="margin-top: -2px" type="ios-arrow-forward"></Icon>
        </div>
        <div v-if="descShowFlag && isMore" @click="descShowFlag = false" class="showMore">收起</div>
        <div class="unscramble">
          <h3>解读</h3>
          <div class="contentInfo" v-html="infoList.unscramble"></div>
        </div>
        <div class="unscramble" v-if="infoList.questionsList && infoList.questionsList[0]">
          <h3>常见问题</h3>
          <Collapse v-model="value1" class="qaBox">
            <Panel :name="item.questionNumber" v-for="(item, index) in infoList.questionsList" :key="index">
              {{ item.questionTitle }}
              <p slot="content">{{ item.questionAnswer }}</p>
            </Panel>
          </Collapse>
          <!-- <div class="contentInfo" v-html="infoList.unscramble"></div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import indexApi from '@/api/index'

export default {
  name: 'evaluationFormula',
  components: {},
  data() {
    return {
      breadcrumb: [],
      descShowFlag: false,
      isMore: false,
      value1: '',
      policyList: [],
      page: {
        total: '',
        pageNo: 1,
        pageSize: 10
      },
      infoList: {}
    }
  },
  mounted() {
    this.getList()
    console.log(this.$route.query.id)
    this.breadcrumb = [
      {
        text: '首页',
        url: '/'
      },
      {
        text: '政策公告',
        url: '/policyaAnnouncement'
      },
      {
        text: '政策解读详情',
        url: ''
      }
    ]
  },
  methods: {
    goDetail() {
      this.$router.push({
        path: '/policyaAnnouncementDetail',
        query: { id: this.$route.query.id },
        replace: true
      })
    },
    changePage(val) {
      this.page.pageNo = val
      this.getList()
    },
    pageChange(val) {
      this.page.pageNo = 1
      this.page.pageSize = val
      this.getList()
    },
    getList() {
      const _this = this
      indexApi.getPolicyInterpretationByPolicyId({ policyId: this.$route.query.id ? this.$route.query.id : '' }).then((res) => {
        console.log(res)
        _this.infoList = res.result
        _this.$nextTick(() => {
          _this.computeHeight()
        })
      })
    },
    computeHeight() {
      const op = document.getElementById('descText').clientHeight
      console.log('op', op)
      if (op > 70) {
        this.isMore = true
      }
    }
  }
}
</script>
<style lang="less">
#descText {
  display: block;
}

.isMoreLine7 {
  max-height: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.qaBox {
  .ivu-collapse-header {
    color: #245bda !important;
    font-size: 16px;
    font-family: MicrosoftYaHeiUI;
    text-align: left;
    line-height: 16px;
    border-bottom: 0px !important;
    height: 60px !important;
    line-height: 60px !important;
  }

  .ivu-collapse-item {
    border-top: 0px !important;
  }
}
</style>
<style lang="less" scoped>
.policyaAnnouncementBox {
  padding-bottom: 202px;

  .contentInfo {
    font-size: 14px;
    font-family: MicrosoftYaHeiUI;
    text-align: justify;
    color: #666666;
    line-height: 32px;
  }

  .clear {
    clear: both;
  }

  .unscramble {
    padding-top: 36px;
    padding-bottom: 40px;

    h3 {
      font-size: 26px;
      font-family: MicrosoftYaHeiUI, MicrosoftYaHeiUI-Bold;
      font-weight: 700;
      text-align: left !important;
      color: #333333;
      line-height: 26px;
      padding-bottom: 16px;
      border-bottom: 1px solid #e8e9ed;
    }

    .contentInfo {
      max-height: 386px;
      overflow-y: scroll;
      overflow-x: hidden;
      font-size: 14px;
      font-family: MicrosoftYaHeiUI;
      text-align: justify;
      color: #666666;
      line-height: 25px;

      /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/

      &::-webkit-scrollbar {
        width: 7px;
        height: 7px;
        background-color: #f5f5f5;
      }

      /*定义滚动条轨道 内阴影+圆角*/

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        background-color: #f5f5f5;
      }

      /*定义滑块 内阴影+圆角*/

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #c8c8c8;
      }
    }
  }

  .qaBox {
    background-color: #fff;
    border: none;
  }

  .bgStyle {
    background: #f8f8f8;
    padding: 16px 10px;

    p {
      font-size: 20px;
      font-family: MicrosoftYaHeiUI;
      text-align: left;
      color: #666666;
      line-height: 20px;
      margin-bottom: 14px;
    }

    span {
      display: block;
      font-size: 14px;
      font-family: MicrosoftYaHeiUI;
      text-align: justify;
      color: #666666;
      line-height: 25px;
    }
  }

  .policyTab {
    height: 60px;
    position: absolute;
    right: 740px;
    top: 275px;

    span {
      display: inline-block;
      width: 180px;
      height: 60px;
      line-height: 60px;
      background: rgba(255, 255, 255, 0.2);
      font-size: 26px;
      font-family: MicrosoftYaHeiUI;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
    }

    .nav-active {
      background: rgba(255, 255, 255, 1);
      font-size: 26px;
      font-family: MicrosoftYaHeiUI, MicrosoftYaHeiUI-Bold;
      font-weight: 700;
      color: #333333;
    }
  }

  .content {
    padding: 24px 420px;
  }

  .data-box {
    padding-top: 33px;

    .showMore {
      display: inline-block;
      width: 100%;
      padding-top: 8px;
      text-align: center;
      font-size: 16px;
      font-family: MicrosoftYaHeiUI;
      color: #245bda;
      cursor: pointer;
      line-height: 16px;
    }

    h3 {
      font-size: 26px;
      text-align: center;
      color: #333333;
      margin-bottom: 20px;
      font-family: MicrosoftYaHeiUI, MicrosoftYaHeiUI-Bold;
      font-weight: 700;
      line-height: 26px;
    }

    .date {
      display: block;
      font-size: 14px;
      font-family: MicrosoftYaHeiUI;
      text-align: center;
      color: #666666;
      line-height: 14px;
      margin-bottom: 16px;
    }

    .apply {
      display: block;
      width: 135px;
      height: 36px;
      border: 1px solid #245bda;
      font-size: 16px;
      font-family: MicrosoftYaHeiUI;
      text-align: center;
      color: #245bda;
      line-height: 34px;
      float: right;
      margin-bottom: 9px;
      cursor: pointer;
    }

    .nodata {
      text-align: center;
      padding: 28px 0;
      font-size: 16px;
      font-family: MicrosoftYaHeiUI;
      color: #2b333f;
      display: inline-block;
      width: 100%;
    }

    .data-wrap {
      display: flex;
      border-bottom: 1px solid #e8e9ed;
      padding: 20px 0;

      .list-left {
        flex: 1;
        font-size: 16px;
        font-family: MicrosoftYaHeiUI;
        text-align: left;
        color: #2b333f;
        height: 36px;
        line-height: 36px;
        cursor: pointer;

        .apply {
          display: inline-block;
          width: 96px;
          height: 28px;
          background: linear-gradient(35deg, #54b8ff 2%, #e567ce 96%);
          border-radius: 20px;
          text-align: center;
          line-height: 28px;
          font-size: 16px;
          font-family: MicrosoftYaHeiUI;
          color: #ffffff;
          margin-left: 10px;
        }
      }

      .list-right {
        width: 228px;

        span {
          display: inline-block;
          cursor: pointer;
        }

        .btn-1 {
          width: 102px;
          height: 36px;
          border: 1px solid #245bda;
          text-align: center;
          font-size: 16px;
          font-family: MicrosoftYaHeiUI;
          color: #245bda;
          line-height: 36px;
          margin-right: 24px;
          float: left;
        }

        .btn-1:hover {
          background: #245bda;
          border: 1px solid #245bda;
          color: #fff;
        }

        .btn-2 {
          width: 102px;
          height: 36px;
          border: 1px solid #dfdede;
          text-align: center;
          font-size: 16px;
          font-family: MicrosoftYaHeiUI;
          color: #333;
          line-height: 36px;
          float: right;
        }

        .btn-2:hover {
          background: #eeeeee;
          border: 1px solid #dfdede;
          color: #333333;
        }
      }
    }

    .data-wrap1 {
      padding: 0;

      span {
        font-size: 14px;
        font-family: MicrosoftYaHeiUI, MicrosoftYaHeiUI-Bold;
        font-weight: 700;
        text-align: left;
        color: #666666 !important;
        line-height: 18px;
        padding-bottom: 13px;
      }
    }
  }

  .data-policy-box {
    .list-center {
      width: 215px;
      font-size: 16px;
      font-family: MicrosoftYaHeiUI;
      text-align: left;
      color: #2b333f;
      height: 36px;
      line-height: 36px;
    }

    .data-wrap {
      .list-left {
        font-size: 16px;
        font-family: MicrosoftYaHeiUI;
        text-align: left;
        color: #245bda;
      }

      .list-right {
        width: 102px;
      }
    }
  }

  .check-box {
    border-top: 1px solid #e8e9ed;
    padding: 29px 0;

    .check-wrap {
      margin-right: 118px;
      font-size: 16px;
      font-family: MicrosoftYaHeiUI;
      text-align: left;
      color: #2b333f;
      margin-bottom: 58px;
    }
  }
}
</style>
<style lang="less">
.check-box {
  .ivu-checkbox-input {
    font-size: 16px;
    font-family: MicrosoftYaHeiUI;
    text-align: left;
    color: #2b333f;
  }
}
</style>
